import React from 'react'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import styles from './errorMessage-style.css'
import Button from 'components/BaseButton/BaseButton'

const propTypes = {
  error: PropTypes.object,
  message: PropTypes.string,
  onRetry: PropTypes.func,
  link: PropTypes.shape({
    label: PropTypes.string,
  }),
}

// Add any default values for props
const defaultProps = null

function ErrorMessage({ link, error, message, onRetry }) {
  if (!error && !message) return null
  const errMsg =
    error && error.body && error.body.message
      ? error.body.message
      : error.message || message
  return (
    <div className={styles.errorMessage}>
      <p>{errMsg}</p>
      {link && <Button primary onClick={onRetry} label={link.label} />}
    </div>
  )
}

ErrorMessage.displayName = 'ErrorMessage'
ErrorMessage.propTypes = propTypes
ErrorMessage.defaultProps = defaultProps

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.js